const TwitterIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    width="16"
    height="16"
    fill="currentColor"
    {...props}
  >
    <path d="M459.4 151.7c.3 4.5.3 9 .3 13.6 0 138.7-105.6 298.4-298.4 298.4A296.77 296.77 0 0 1 0 408.1a218.3 218.3 0 0 0 25.6 1.3 209.9 209.9 0 0 0 130.1-44.9 104.9 104.9 0 0 1-97.9-72.7 132.3 132.3 0 0 0 19.9 1.6 110.5 110.5 0 0 0 27.5-3.6 104.8 104.8 0 0 1-83.9-102.8v-1.3a105.4 105.4 0 0 0 47.4 13.2 104.9 104.9 0 0 1-32.4-139.8 298.1 298.1 0 0 0 216.5 109.8 104.9 104.9 0 0 1 178.7-95.6 209.1 209.1 0 0 0 66.5-25.4 104.9 104.9 0 0 1-46.1 57.9 209.1 209.1 0 0 0 60.4-16.2 224.4 224.4 0 0 1-52.6 54.6z" />
  </svg>
);

export default TwitterIcon;
